"use client";

import React, { useState } from "react";
import { Button, Input, message } from "antd";
import StudioPlayer from "../component/Studio/StudioPlayer";
import { studioApi } from "../api"; 

function NewPlayer() {
  const [url, setUrl] = useState("");
  const [playingUrl, setPlayingUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePlay = async () => {
    if (!url.trim()) return;

    try {
      setLoading(true);

      const { data } = await studioApi.post<{
        signed_url: string;
        expires_in: number;
      }>("/videos/signed-url", {
        url,
      });

      setPlayingUrl(data.signed_url);
    } catch (e: any) {
      message.error(e?.message || "Failed to generate signed URL");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "100%", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          gap: 8,
          padding: 10,
        }}
      >
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Enter .m3u8 URL"
          onPressEnter={handlePlay}
        />

        <Button
          type="primary"
          onClick={handlePlay}
          loading={loading}
        >
          Play
        </Button>
      </div>

     
        <StudioPlayer
          videoUrl={playingUrl}
          player="new"
        />
  
    </div>
  );
}

export default NewPlayer;